import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-strength',
  templateUrl: './student-strength.component.html',
  styleUrls: ['./student-strength.component.scss']
})
export class StudentStrengthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
